export default "https://d5n98rwtlo2nl.cloudfront.net/ticket-flow/fonts/WorkSans-VariableFont_wght.ttf"